import React from 'react'

import { css, Theme } from '@emotion/react'
import styled from '@emotion/styled'

import { Grid } from '../../layout/Grid'
import BaseCell, { BaseCellProps } from '../BaseCell/BaseCell'

export const CellButtonWrapper = styled.button<{ disabled: boolean }>`
  background: none;
  border: none;
  display: block;
  margin: -${props => props.theme.spacing.m};
  padding: ${props => props.theme.spacing.m};
  overflow: visible;
  font: inherit;
  color: inherit;
  text-align: inherit;
  line-height: inherit; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  ${({ theme, disabled }) => cellHoverStyles(theme, disabled)}
  outline: none;

  /* focused */
  ${({ theme }) => theme.selectors.keyboard} &:focus {
    border-radius: 0.25rem;
    outline: 0.125rem solid ${({ theme }) => theme.arcadeColors.component.inputBorderFocus};
  }
`

export const cellHoverStyles = (theme: Theme, disabled: boolean) => css`
  @media (hover: hover) {
    &:hover {
      ${!disabled &&
      `
        background-color: ${theme.arcadeColors.component.cellBackgroundHover};
        border-radius: ${theme.border.radius.small};
      `}
    }
  }
`

export interface InteractiveCellProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, Pick<BaseCellProps, 'label'> {
  cellProps?: Omit<BaseCellProps, 'disabled' | 'label'>
  'data-testid'?: string
}

const InteractiveCell = React.forwardRef<HTMLDivElement, InteractiveCellProps>(
  ({ label, disabled = false, cellProps, ...restProps }, ref) => {
    return (
      <Grid>
        <CellButtonWrapper {...restProps} disabled={disabled}>
          <BaseCell label={label} {...cellProps} disabled={disabled} ref={ref} />
        </CellButtonWrapper>
      </Grid>
    )
  }
)

export default InteractiveCell
